<template>
  <div>
    <el-button v-if="!!fileId" type="text" size="medium" @click="openVideoViewer()">观看</el-button>
    <el-button v-if="!!fileId" :loading="isDownloading" type="text" size="medium" @click="downloadCellFile(item)">下载</el-button>

    <videoViewer key="videoViewer" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :fileId="fileId" />
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import { downloadFile } from "@/config/mUtils.js";
import {
  getBlobFileUrlById,
  downloadFileToBlob,
} from "@/service/blobStorage.service";
export default {
  props: {
    data: {},
  },
  data() {
    return {
      fileId: 0,
      isDownloading: false,
    };
  },
  components: {
    videoViewer: () => import("@/components/common/videoViewer"),
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!!this.data) {
        this.fileId = this.data.InterviewRecordingId;
      }
    },
    openVideoViewer() {
      let videoViewer = this.$vueRefStore.getChildrenRef(
        "videoViewer"
      );
      if (!videoViewer) return;

      videoViewer.showDialog();
    },
    closeVideoViewer() {
      let videoViewer = this.$vueRefStore.getChildrenRef(
        "videoViewer"
      );
      if (!videoViewer) return;

      videoViewer.closeDialog();
    },
    downloadCellFile(item) {
      this.isDownloading = true;
      getBlobFileUrlById(this.fileId)
        .then((result) => {
          if (!!result && result.success) {
            let { Url, FileName } = result.data;
            downloadFileToBlob(Url, 0).then((res) => {
              downloadFile({ data: res.data, filename: FileName });
              this.isDownloading = false;
            });
          } else {
            if (!!result.message) {
              this.$message.error(result.message);
            }
            this.isDownloading = false;
          }
        })
        .catch(() => {});
    },
  },
  watch: {
    data: function () {
      this.init();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/interviewRecordingCell.vue